export default "__VITE_ASSET__EyjojYZP__"